import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import { deviceMax } from '../../theme/breakpoints'

export const StyledBlock = styled.div`
  //Get 16/9 ratio
  width: 100%;
  justify-content: center;
  display: flex;
  aspect-ratio: 16/9;

  video,
  img,
  iframe {
    width: 100%;
    height: 100%;
    border-radius: ${pxToRem(5)};
    box-sizing: border-box;
    object-fit: cover;
  }

  @media ${deviceMax.tablet} {
    max-width: 100%;
    margin: ${pxToRem(30)} 0 0 0;
    video,
    img,
    iframe {
      border-radius: 0;
    }
  }
`
